import { createContext } from 'react'
import type { NotificationContextProps } from '../provider'

export const NotificationContext = createContext<
    NotificationContextProps | undefined
>(undefined)
